export const openWhatsapp = (service) => {
  return `https://wa.me/+56963409817?text=Hola, me gustaría conocer más del servicio "${service}" para eventualmente realizar una reserva`;
};
